/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_Cozy_Marten_TearInputs */

const fr_last_cozy_marten_tear = /** @type {(inputs: Last_Cozy_Marten_TearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes vous sur de vouloir supprimer la section ?`)
};

/**

* @param {Last_Cozy_Marten_TearInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const last_cozy_marten_tear = /** @type {((inputs?: Last_Cozy_Marten_TearInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Cozy_Marten_TearInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_last_cozy_marten_tear(inputs)
});